import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { History } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import WidgetCard from '../components/WidgetCard';
import { labelText } from '../lib/knowledge';
import type { TimelineEvent } from '../lib/types';
import type { WidgetProps } from './types';

const DEFAULT_LIMIT = 8;

// The latest events on the company timeline.
export default function RecentTimeline({ config }: WidgetProps<{ limit?: number }>) {
  const { authFetch } = useAuth();
  const [events, setEvents] = useState<TimelineEvent[] | null>(null);
  const limit = config.limit ?? DEFAULT_LIMIT;

  useEffect(() => {
    authFetch('/knowledge/timeline')
      .then(r => r.ok ? r.json() : [])
      .then(setEvents)
      .catch(() => setEvents([]));
  }, [authFetch]);

  if (!events || events.length === 0) return null;

  return (
    <WidgetCard
      title="Recent events"
      icon={History}
      action={<Link to="/timeline" className="text-[12px] text-brand-dark hover:underline">See the timeline</Link>}
    >
      <ul className="divide-y divide-softgrey/60">
        {events.slice(0, limit).map(ev => (
          <li key={`${ev.id}:${ev.event}`} className="py-2 flex items-baseline gap-3">
            <span className="text-[11px] text-coolslate w-20 shrink-0">
              {new Date(ev.at).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-[13px] text-graphite truncate">
                {ev.event === 'ended' ? 'Ended: ' : ''}{ev.title}
              </span>
              <span className="block text-[11px] text-coolslate">{labelText(ev.type)}</span>
            </span>
          </li>
        ))}
      </ul>
    </WidgetCard>
  );
}
